import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { ConfigProvider, theme } from 'antd'
import { RawIntlProvider } from 'react-intl'
import dayjs from 'dayjs'
import 'dayjs/locale/ro'

import english from './locales/en'
import romanian from './locales/ro'

import { IntlSetup } from './intlSetup'

dayjs.locale('en')

const defaultLocale = {
  en: english,
  ro: romanian,
}

const Localization = props => {
  const { children } = props
  const lang = useSelector(s => s._settings.locale)
  const isDarkAlgoritm = useSelector(s => s._settings.antd_darkAlgorithm)

  useEffect(() => {
    dayjs.locale(lang)
  }, [lang])

  const CoreLocale = defaultLocale[lang] || defaultLocale.en

  const intl = IntlSetup({ locale: defaultLocale.en, messages: CoreLocale.messages })

  const ConfigProviderDefaultProps = {
    locale: CoreLocale.antdData,
    theme: {
      algorithm: isDarkAlgoritm ? theme.darkAlgorithm : theme.defaultAlgorithm,
    },
  }

  return (
    <ConfigProvider {...ConfigProviderDefaultProps}>
      <RawIntlProvider value={intl}>{children}</RawIntlProvider>
    </ConfigProvider>
  )
}

export default Localization
